

<template>

  <div class="main-div">

    <pre id="json-renderer"></pre>



    <log-filters :subject-options="subjectOptions" :subject-filter.sync="subjectFilter" :causer-options="causerOptions"
      :causer-filter.sync="causerFilter" :event-options="eventOptions" :event-filter.sync="eventFilter"
      :from.sync="from" :to.sync="to">
    </log-filters>


    <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
      <label>{{ $t('Show') }}</label>
      <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
        :clearable="false" class="per-page-selector d-inline-block mx-50" />
      <label>{{ $t('entries') }}</label>
    </b-col>




    <b-card class="mt-2">

      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <app-timeline>

        <app-timeline-item v-for="log in logs" variant="warning" icon="TruckIcon" :key="log.id">

          <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">


            <p><span class="title"> Causer Name:</span>{{ log.user }}</p>

            <small class="text-muted">45 min ago</small>
          </div>
          <p><span class="title"> event:</span> {{ log.event }}</p>
          <p><span class="title">subject_type :</span> {{log.subject_type}}</p>
          <p><span class="title">subject_name :</span> {{log.subject_name}}</p>
          <p><span class="title">subject_id :</span> {{log.subject_id}}</p>
          <p><span class="title">date time :</span> {{log.date_time}}</p>


          <div v-html="json2html(log.properties)" @click="handleCollapse" />

        </app-timeline-item>

        <p v-if="logs.length < 1"> no activity found</p>

      </app-timeline>
    </b-card>

    <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" first-number last-number
      class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
      <template #prev-text>
        <feather-icon icon="ChevronLeftIcon" size="18" />
      </template>
      <template #next-text>
        <feather-icon icon="ChevronRightIcon" size="18" />
      </template>
    </b-pagination>
  </div>
</template>
<script>
global.jQuery = require('./jquery.min.js');
//require('./jquery.json-viewer.js');
var $ = global.jQuery;

import {
  BImg,
  BAvatar,
  BMedia,
  BButton,
  BCollapse,
  VBToggle,
  BListGroup,
  BListGroupItem,
  BAvatarGroup, BCol,
  BPagination,
  BBadge,
  VBTooltip,
  BCard,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import useActivityLog from './useActivityLog'
import LogFilters from './LogFilters'
import { OrbitSpinner } from 'epic-spinners'
import vSelect from 'vue-select'
import { VTree } from 'vue-tree-halower'
import { codeAsync } from './code'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
export default {


  components: {
    AppTimeline,
    AppTimelineItem,
    BPagination,
    BImg, vSelect,
    BMedia,
    BAvatar, BCard,
    BButton, BCol,
    BCollapse,
    BListGroup, OrbitSpinner,
    BListGroupItem,
    BAvatarGroup, LogFilters,
    BBadge,
    VTree,
    codeAsync,
    BCardCode
  },
  data() {
    return {
      jq: global.jQuery,
      codeAsync,
      initSelected: ['node-1'],
      treeData: [
        {
          title: 'node1',
          expanded: false,
          async: true,
        },
      ],
    }
  },
  // watch:{
  //   currentPage(nv, ov) {
  //     reformatLog()
  // },
  // perPage(nv, ov) {
  //     reformatLog()
  // },
  // },
  methods: {
    handleLineClick(e) {
      let clickedElId = e.target.id
      if (clickedElId === 'temp_testing_div2') {
        console.log("temp_testing_div2 clicked!", e)
      } else {
        console.log('another element was clicked')
      }
    },
    handleCollapse: function (e) {
      //var jQuery = require('./jquery.min.js');
      window.$ = window.jQuery = require('./jquery.min.js');





      var target = $(e.target).toggleClass('collapsed').siblings('ul.json-dict, ol.json-array');
      target.toggle();

      if (target.is(':visible')) {
        target.siblings('.json-placeholder').remove();
      } else {
        var count = target.children('li').length;
        var placeholder = count + (count > 1 ? ' items' : ' item');
        target.after('<a href=" javascript:void(0);" class="json-placeholder">' + placeholder + '</a>');
      }
      return false;

      //e.target.classList.add("collapsed");

      console.log('another element was clicked', e)

    },

    json2html(json) {

      const options = Object.assign({}, {
        collapsed: false,
        rootCollapsable: true,
        withQuotes: false,
        withLinks: true,
        bigNumbers: false
      }, options);
      var html = '';
      if (typeof json === 'string') {
        // Escape tags and quotes
        json = this.htmlEscape(json);

        if (options.withLinks && this.isUrl(json)) {
          html += '<a href="' + json + '" class="json-string" target="_blank">' + json + '</a>';
        } else {
          // Escape double quotes in the rendered non-URL string.
          json = json.replace(/&quot;/g, '\\&quot;');
          html += '<span class="json-string">"' + json + '"</span>';
        }
      } else if (typeof json === 'number' || typeof json === 'bigint') {
        html += '<span class="json-literal">' + json + '</span>';
      } else if (typeof json === 'boolean') {
        html += '<span class="json-literal">' + json + '</span>';
      } else if (json === null) {
        html += '<span class="json-literal">null</span>';
      } else if (json instanceof Array) {
        if (json.length > 0) {
          html += '[<ol class="json-array">';
          for (var i = 0; i < json.length; ++i) {
            html += '<li>';
            // Add toggle button if item is collapsable
            if (this.isCollapsable(json[i])) {
              html += '<a href class="json-toggle"></a>';
            }
            html += this.json2html(json[i], options);
            // Add comma if item is not last
            if (i < json.length - 1) {
              html += ',';
            }
            html += '</li>';
          }
          html += '</ol>]';
        } else {
          html += '[]';
        }
      } else if (typeof json === 'object') {
        // Optional support different libraries for big numbers
        // json.isLosslessNumber: package lossless-json
        // json.toExponential(): packages bignumber.js, big.js, decimal.js, decimal.js-light, others?
        if (options.bigNumbers && (typeof json.toExponential === 'function' || json.isLosslessNumber)) {
          html += '<span class="json-literal">' + json.toString() + '</span>';
        } else {
          var keyCount = Object.keys(json).length;
          if (keyCount > 0) {
            html += '{<ul class="json-dict">';
            for (var key in json) {
              if (Object.prototype.hasOwnProperty.call(json, key)) {
                key = this.htmlEscape(key);
                var keyRepr = options.withQuotes ?
                  '<span class="json-string">"' + key + '"</span>' : key;

                html += '<li>';
                // Add toggle button if item is collapsable
                if (this.isCollapsable(json[key])) {
                  html += '<a  href="javascript:void(0);"  class="json-toggle">' + keyRepr + '</a>';
                } else {
                  html += keyRepr;
                }
                html += ': ' + this.json2html(json[key], options);
                // Add comma if item is not last
                if (--keyCount > 0) {
                  html += ',';
                }
                html += '</li>';
              }
            }
            html += '</ul>}';
          } else {
            html += '{}';
          }
        }
      }
      return html;
    },
    htmlEscape(s) {
      return s.replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&apos;')
        .replace(/"/g, '&quot;');
    },

    isCollapsable(arg) {
      return arg instanceof Object && Object.keys(arg).length > 0;
    },

    isUrl(string) {
      var protocols = ['http', 'https', 'ftp', 'ftps'];
      for (var i = 0; i < protocols.length; ++i) {
        if (string.startsWith(protocols[i] + '://')) {
          return true;
        }
      }
      return false;
    }
  },

  directives: { 'b-toggle': VBToggle, 'b-tooltip': VBTooltip, Ripple },
  setup() {
    const rawHtml = `<button>Raw Html</button>`

    const {
      perPage, currentPage, fetchLog, total, logs, requestStatus, perPageOptions,

      subjectOptions, subjectFilter,

      causerOptions, causerFilter,
      eventOptions, eventFilter,
      nameOptions, nameFilter,
      from, to



    } = useActivityLog()



    fetchLog()

    return {
      logs, currentPage, total, perPage, requestStatus, perPageOptions,

      subjectOptions, subjectFilter,
      causerOptions, causerFilter,
      eventOptions, eventFilter,
      nameOptions, nameFilter,
      from, to,
      rawHtml,
      //handleLineClick
    }
  }


}



</script>





<style lang="scss" scoped>
@import './jquery.json-viewer.css';


li {
  color: blue;
}

.title {
  color: #a40fb9;
  font-size: 1.2rem;
}


</style>

